import { useState, useEffect, useCallback, useRef } from "react";
import { Box } from "@mui/material";
import { useStockControlStore } from "../../hooks/useStockControlStore";
import { useControlStockVoluntario } from "../../helpers/useControlStockVoluntario";
import { scanProduct } from "../../helpers/nativeInterface";
import FormularioBase from "./FormularioBase";
import CustomTextField from "./CustomTextField";
import CodigoBarrasInput from "./CodigoBarrasInput";

const FormularioVoluntario = ({ mostrarTipoControl = true, tituloAlternativo }) => {
  const { codigoBarra, setCodigoBarra, articulo, resetFormulario } = useStockControlStore();
  const [ultimoBusqueda, setUltimoBusqueda] = useState("");
  const timeoutRef = useRef(null);

  const { buscarArticuloYVerificarAjuste, loading } = useControlStockVoluntario();

  const handleAbrirScanner = () => {
    scanProduct();
  };

  // useEffect para limpiar el estado al montar y desmontar el componente
  useEffect(() => {
    // Limpiar estado al montar el componente
    resetFormulario();
    setUltimoBusqueda("");

    // Cleanup al desmontar el componente
    return () => {
      resetFormulario();
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []); // Solo se ejecuta al montar/desmontar

  // useEffect para el scanner físico
  useEffect(() => {
    const eventListener = async event => {
      const barcode = event.detail.barcode;
      setCodigoBarra(barcode);

      if (barcode.trim()) {
        setUltimoBusqueda(barcode);
        buscarArticuloYVerificarAjuste(barcode, new Date().toISOString().split("T")[0]);
      }
    };

    window.addEventListener("scanComplete", eventListener);

    return () => {
      window.removeEventListener("scanComplete", eventListener);
    };
  }, [setCodigoBarra, buscarArticuloYVerificarAjuste]);

  // useEffect para búsqueda automática cuando se escribe manualmente
  useEffect(() => {
    // Limpiar timeout anterior
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Solo buscar si el código cambió y no está vacío
    if (codigoBarra && codigoBarra.trim() !== "" && codigoBarra !== ultimoBusqueda) {
      timeoutRef.current = setTimeout(() => {
        setUltimoBusqueda(codigoBarra);
        buscarArticuloYVerificarAjuste(codigoBarra, new Date().toISOString().split("T")[0]);
      }, 1000); // 3 segundos de debounce
    }

    // Cleanup function
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [codigoBarra, ultimoBusqueda, buscarArticuloYVerificarAjuste]);

  const camposPersonalizados = (
    <Box width={310} mb={2}>
      {/* ARTÍCULO */}
      <CustomTextField label="ARTÍCULO" value={articulo?.descripcion ?? ""} disabled loading={loading} />

      {/* CÓDIGO ARTÍCULO + LEER CÓDIGO */}
      <CodigoBarrasInput codigoBarra={codigoBarra} setCodigoBarra={setCodigoBarra} onScan={handleAbrirScanner} loading={loading} />
    </Box>
  );

  return (
    <>
      <FormularioBase
        mostrarTipoControl={mostrarTipoControl}
        tituloAlternativo={tituloAlternativo}
        camposPersonalizados={camposPersonalizados}
        mostrarBotones={false}
        loading={loading}
      />
    </>
  );
};

export default FormularioVoluntario;
